import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showResetGuestLinkModal } from '../../../../actions/modal';
import { resetGuestLink, updateMeetingRoomForm } from '../../../../actions/meetingRoom';
import { displayGlobalMessage } from 'actions/globalMessage';
import Info from '../../info';

export default function ResetGuestLinkRightBottomPanel(props) {
  const dispatch = useDispatch();
  const [resetingGuestLink, setResetingGuestLink] = useState(false);
  const [hasResetGuestLink, setHasResetGuestLink] = useState(false);

  const copyInvitationLinkToClipboard = (roomId) => {
    var clipboard = new window.Clipboard('.copy-to-clipboard-button-meeting-room-reset-link', {
      text: () => {
        return props.selectedMeetingRoom.roomUrl;
      },
    });
  };

  const showCopyLinkToClipboardGlobalMessage = (meetingRoomName) => {
    console.log('Meeting room copy link:' + props.selectedMeetingRoom.roomUrl);
    navigator.clipboard.writeText(props.selectedMeetingRoom.roomUrl);
    setTimeout(() => {
      var successMessage = APP.LANGUAGE.CopyLinkToClipboard.SuccessfulMessage.replace(
        '##meetingRoom##',
        meetingRoomName
      );
      dispatch(
        displayGlobalMessage({
          text: successMessage,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
          autoHide: true,
        })
      );
      dispatch(showResetGuestLinkModal(false));
    }, 1000);
  };

  const closeModal = () => {
    dispatch(showResetGuestLinkModal(false));
  };

  const clickSaveBtn = () => {
    setResetingGuestLink(true);

    let cb = (closeModal) => {
      setResetingGuestLink(false);
      setHasResetGuestLink(true);
      navigator.clipboard.writeText(props.selectedMeetingRoom.roomUrl);
    };
    dispatch(resetGuestLink(props.selectedMeetingRoom, cb));
  };

  let saveClasses =
    'ui labeled icon button icon left-text color-button color-button-hover color-white max-width mrlnull mrbnull';
  let saveCancelBtnClass =
    'ui labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull';

  return (
    <div>
      <div className="ui actions mrbl mrtxxs max-width">
        {hasResetGuestLink ? (
          <button
            type="button"
            id="reset-meeting-room-link-btn"
            onClick={() => showCopyLinkToClipboardGlobalMessage(props.selectedMeetingRoom.name)}
            className={saveClasses + ' copy-to-clipboard-button-meeting-room-reset-link'}
          >
            {APP.LANGUAGE.ResetGuestLink.CopyBtn}
            <i className="copy icon" />
          </button>
        ) : (
          <button
            type="button"
            id="reset-meeting-room-link-btn"
            onClick={clickSaveBtn}
            className={resetingGuestLink ? saveClasses + ' loading' : saveClasses}
          >
            {APP.LANGUAGE.ResetGuestLink.ResetBtn}
            <i className="refresh icon" />
          </button>
        )}
        <button
          type="button"
          onClick={closeModal}
          className={resetingGuestLink ? saveCancelBtnClass + ' disable' : saveCancelBtnClass}
        >
          <i className="remove  icon" />
          {hasResetGuestLink ? APP.LANGUAGE.Close : APP.LANGUAGE.Cancel}
        </button>
      </div>
      <div className="mrtl">
        <Info paragraphs={[APP.LANGUAGE.ResetGuestLink.Info]} />
      </div>
    </div>
  );
}
